import * as React from 'react';
import { Lock } from '@/icons/lock';

type Props = {
  channelName: string | undefined;
  tacticName: string | undefined;
  unitPriceTypeName: string | undefined;
};

export function LockedChannelTacticType({ channelName, tacticName, unitPriceTypeName }: Props) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap gap-2">
        <LockedField
          label="Channel"
          value={channelName ?? '—'}
          className="@[740px]:w-[calc(50%-0.25rem)] @[1000px]:w-[calc(33.333%-0.375rem)]"
        />
        <LockedField
          label="Tactic"
          value={tacticName ?? '—'}
          className="@[740px]:w-[calc(50%-0.25rem)] @[1000px]:w-[calc(33.333%-0.375rem)]"
        />
        <LockedField
          label="Unit Price Type"
          value={unitPriceTypeName ?? '—'}
          className="@[1000px]:w-[calc(33.333%-0.375rem)]"
        />
      </div>
      <span className="text-center text-sm text-gray-500">
        Channel, Tactic, and Unit Price Type cannot be edited after publishing
      </span>
    </div>
  );
}

function LockedField({
  label,
  value,
  className
}: {
  label: string;
  value: string;
  className?: string;
}) {
  return (
    <div
      className={`rounded bg-gray-800 text-white flex justify-between py-2 px-3 items-center w-full ${className ?? ''}`}>
      <div className="font-semibold text-sm">{label}</div>
      <div className="flex items-center gap-2">
        <div className="text-right">{value}</div>
        <div className="border-l-[1px] border-gray-400 pl-2">
          <Lock />
        </div>
      </div>
    </div>
  );
}
